import { When } from 'react-if';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import S from './FeatureCard.module.scss';
export const FeatureCard = (props: FeatureCardProps) => {
  const {
    title,
    description,
    imageUrl,
    imageAlt,
    isPremiumAppButton
  } = props;
  const {
    t
  } = useTranslation(['subscription'], {
    useSuspense: true
  });
  return <div className={S.card} data-sentry-component="FeatureCard" data-sentry-source-file="FeatureCard.tsx">
      <div className={S.header}>
        <strong className={S.title}>{title}</strong>
        <span className={S.description}>{description}</span>
        {isPremiumAppButton && <div>
            <Button as="a" variant="secondary" size="xxs" href={t('subscription:pricing.comparison.premiumAppLink')} target="_blank">
              {t('subscription:pricing.d50bbd13', '앱 사용 가이드')}
            </Button>
          </div>}
      </div>
      <div className={S.content}>
        <div className={S.image}>
          <When condition={imageUrl} data-sentry-element="When" data-sentry-source-file="FeatureCard.tsx">
            <Image src={imageUrl} alt={imageAlt ?? ''} width={744} height={460} data-sentry-element="Image" data-sentry-source-file="FeatureCard.tsx" />
          </When>
        </div>
      </div>
    </div>;
};
export type FeatureCardProps = {
  title: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  isPremiumAppButton?: boolean;
};